import { PROJECT_FETCHING, PROJECT_FAILED, PROJECT_SUCCESS } from "./types";

import ProjectService from "../services/project.service";

export const getAllProject = () => async (dispatch) => {
  try {
    const res = await ProjectService.getAllProject();
    if (res) {
      dispatch({
        type: PROJECT_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: PROJECT_FAILED,
    });
    console.log(err);
  }
};
